import { type Product } from '@/infra/services/catalog/product/get-product-info/model';

class Base {
  thumbSrc: string;
  alt: string;

  constructor({ alt, thumbSrc }: { thumbSrc: string; alt: string }) {
    this.thumbSrc = thumbSrc;
    this.alt = alt;
  }
}

export class Image extends Base {
  height: number;
  width: number;
  src: string;
  zoomSrc: string;

  constructor({
    alt,
    height,
    src,
    thumbSrc,
    width,
    zoomSrc,
  }: {
    height: number;
    width: number;
    thumbSrc: string;
    alt: string;
    src: string;
    zoomSrc: string;
  }) {
    super({ thumbSrc, alt });

    this.height = height;
    this.width = width;
    this.src = src;
    this.zoomSrc = zoomSrc;
  }
}

export class Video extends Base {
  youtubeId: string;

  constructor({
    alt,
    thumbSrc,
    youtubeId,
  }: {
    youtubeId: string;
    thumbSrc: string;
    alt: string;
  }) {
    super({ thumbSrc, alt });

    this.youtubeId = youtubeId;
  }
}

export class Sketch3D extends Base {
  modelId: string;

  constructor({
    alt,
    modelId,
    thumbSrc,
  }: {
    modelId: string;
    thumbSrc: string;
    alt: string;
  }) {
    super({ thumbSrc, alt });

    this.modelId = modelId;
  }
}

export type Media = Image | Video | Sketch3D;

const buildVisualMedias = (visualMedias: Product['visualMedias']) => {
  const medias: Array<Image | Video | Sketch3D> = [];

  visualMedias.medias.forEach((current) => {
    const { alt, main, miniature, youtubeId, zoom } = current;

    if (youtubeId) {
      medias.push(
        new Video({
          alt,
          thumbSrc: `https://img.youtube.com/vi_webp/${youtubeId}/0.webp`,
          youtubeId,
        })
      );
    } else if (main && miniature && zoom) {
      medias.push(
        new Image({
          alt,
          height: 400,
          width: 400,
          src: main,
          thumbSrc: miniature,
          zoomSrc: zoom,
        })
      );
    }
  });

  if (visualMedias.sketchFabImage) {
    medias.push(
      new Sketch3D({
        alt: 'Modelo 3d',
        modelId: visualMedias.sketchFabImage,
        thumbSrc: '/images/catalog/product/sketchfab-placeholder.svg',
      })
    );
  }

  return medias;
};

export default buildVisualMedias;
